var WarmupQuestions = require("lib/academic/WarmupQuestions");

class FictionPlotQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionPlotQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [EVENT_1_STAGE];
		}

		var event1Complete = answers[EVENT_1_CHAR] && answers[EVENT_1_ACTION] && (this.props.level != "3" || answers[EVENT_1_TYPE]);
		var event2Complete = answers[EVENT_2_CHAR] && answers[EVENT_2_ACTION] && (this.props.level != "3" || answers[EVENT_2_TYPE]);

		if (!event1Complete) {
			return [EVENT_1_STAGE];
		} else if (!event2Complete) {
			return [EVENT_2_STAGE];
		} else {
			return [EVENT_2_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		if (this.props.level == "3") {
			var event1TypeDisplay = (
				<div>
					{ this.props.getTextF("label4", EVENT_1_STAGE) }
					{ this.props.renderDropdownF("choices4", EVENT_1_STAGE, EVENT_1_TYPE) }
				</div>
			);
		}

		var event1Display = (
			<div>
				{ this.props.getTextF("label1", EVENT_1_STAGE) }
				<br />
				<div className="inputGroup">
					{ this.props.renderInputF(EVENT_1_CHAR) }
					<br />
					<span className="subtext">
						{ this.props.getTextF("label2", EVENT_1_STAGE) }
					</span>
				</div>
				<div className="inputGroup">
					{ this.props.renderInputF(EVENT_1_ACTION) }
					<br />
					<span className="subtext">
						{ this.props.getTextF("label3", EVENT_1_STAGE) }
					</span>
				</div>
				<br />
				{ event1TypeDisplay }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			if (this.props.level == "3") {
				var event2TypeDisplay = (
					<div>
						{ this.props.getTextF("label4", EVENT_2_STAGE) }
						{ this.props.renderDropdownF("choices4", EVENT_2_STAGE, EVENT_2_TYPE) }
					</div>
				);
			}

			var event2Display = (
				<div className="topMargin">
					{ this.props.getTextF("label1", EVENT_2_STAGE) }
					<br />
					<div className="inputGroup">
						{ this.props.renderInputF(EVENT_2_CHAR) }
						<br />
						<span className="subtext">
							{ this.props.getTextF("label2", EVENT_2_STAGE) }
						</span>
					</div>
					<div className="inputGroup">
						{ this.props.renderInputF(EVENT_2_ACTION) }
						<br />
						<span className="subtext">
							{ this.props.getTextF("label3", EVENT_2_STAGE) }
						</span>
					</div>
					<br />
					{ event2TypeDisplay }
				</div>
			);
		}

		return (
			<div>
				{ event1Display }
				{ event2Display }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionPlotQuestion.STEM = "fplot";

// stages
var EVENT_1_STAGE = "event1";
var EVENT_2_STAGE = "event2";

var STAGES = [
	EVENT_1_STAGE, EVENT_2_STAGE
];

// answer keys
var EVENT_1_CHAR = "event_1_char";
var EVENT_1_ACTION = "event_1_action";
var EVENT_1_TYPE = "event_1_type";
var EVENT_2_CHAR = "event_2_char";
var EVENT_2_ACTION = "event_2_action";
var EVENT_2_TYPE = "event_2_type";

FictionPlotQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionPlotQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionPlotQuestion.js